import { LogoCloudCarousel } from "../../../../modules/logo-cloud/components/LogoCloudCarousel/LogoCloudCarousel";
import { LogoCloudGrid } from "../../../../modules/logo-cloud/components/LogoCloudGrid/LogoCloudGrid";
import type { ILogoCloudBlockProps } from "./LogoCloudBlock.props";

export const LogoCloudBlock = ({ items, variant, ...props }: ILogoCloudBlockProps) => {
  if (!items?.length) {
    return null;
  }

  if (variant === "carousel") {
    return <LogoCloudCarousel {...props} items={items} />;
  }

  if (variant !== null && variant !== undefined && variant !== "grid") {
    return null;
  }

  return <LogoCloudGrid {...props} items={items} variant={variant} />;
};

LogoCloudBlock.displayName = "Block::LogoCloudBlock";
